import React, { useEffect, useState } from 'react';
import { getExpenses, deleteExpenses } from '~/services/hooks/expenses';
import Box from '~/components/Box';
import { Table, TableHeader } from '~/components/Table';
import { Col, Input, message } from 'antd';
import Pagination from '~/components/Pagination';
import Global from '~/styles/global';
import { useTranslation } from 'react-i18next';
import Button from '~/components/Button';
import ExpensesModal from './form';
import { useCheckAuth } from '~/components/Can/checkAuth';
import ColButton from '~/components/ColButton';
import IsMobile from '~/services/mobileCheck';
import { expensesColumns } from '~/tables/expenses';
import errorHandler from '~/Utils/errorHandler';

export default function Expenses() {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const isMobile = IsMobile();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [search, setSearch] = useState('');
  const [expensesEdit, setExpensesEdit] = useState({});
  const [ModalVisible, setModalVisible] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
          search,
        },
      };
      const data = await getExpenses(params);
      setData(data.data);
      setMeta(data.meta);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleEdit = (record) => {
    setExpensesEdit(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await deleteExpenses(id);
      message.success(t('Despesa excluída'));
      fetchData();
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, perPage, search]);

  return (
    <Box>
      <ColButton>
        <Button color="primary" onClick={() => handleEdit(null)} disabled={!authCheck('@eventsExpenses/create')}>
          {t('screens:expenses.addExpenses')}
        </Button>
      </ColButton>
      <TableHeader>
        <Col style={{ display: 'flex' }}>
          <Input.Search
            onSearch={(value) => {
              setSearch(value);
              setPage(1);
            }}
            className="search-field"
            placeholder={t('screens:default.search')}
          />
        </Col>
      </TableHeader>
      <Table
        pagination={false}
        rowKey="id"
        loading={loading}
        dataSource={data}
        columns={expensesColumns(handleEdit, handleDelete, isMobile)}
        bordered
      />
      <Pagination
        isMobile={isMobile}
        onChange={(value) => {
          setPage(value);
        }}
        meta={meta}
        perPage={perPage}
        setPerPage={setPerPage}
      />
      <Global />
      <ExpensesModal
        visible={ModalVisible}
        expensesEdit={expensesEdit}
        isMobile={isMobile}
        onClose={() => {
          setModalVisible(false);
          setExpensesEdit(null);
          fetchData();
        }}
      />
    </Box>
  );
}
